import { render } from "./DataImportTemplates.vue?vue&type=template&id=08a9281e"
import script from "./DataImportTemplates.vue?vue&type=script&lang=js"
export * from "./DataImportTemplates.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__